export default __webpack_public_path__ + "static/media/Icon.e05b6872.png";